/*
  Phantasmagorical: buy-more-save-more note.
  Shows "Buy 2 save 10% · Buy 3+ save 15%" on the PDP (near the buy box) and in the
  cart/drawer (under the free-shipping bar) so warm shoppers see the automatic
  quantity discount. Upgrade-safe: loaded via theme-globals.liquid, self-contained.

  Black Friday 2026 window (added 2026-10-09). From 2026-11-24T18:00:00Z to
  2026-12-01T08:00:00Z (10:00am Pacific on Nov 24 to midnight Pacific at the end of
  Nov 30), the same window as the two scheduled automatic discounts, this file shows
  20% and 30% instead: in this note, in the announcement bar and in the product page
  Shipping tab. Outside the window it behaves exactly as it did before. Nothing has
  to be switched by hand. To remove it after the sale, restore the earlier version
  of this one file.

  Sets: the set products are taken off the store for that week. While the Sets
  collection is empty, the header menu links to it are hidden, so nobody lands on an
  empty page. It checks the collection itself, so if the sets stay up, the links stay.
*/
(function () {
  'use strict';
  if (window.__pgVolNoteInstalled) return;
  window.__pgVolNoteInstalled = true;

  var SALE_START = Date.UTC(2026, 10, 24, 18, 0, 0);
  var SALE_END = Date.UTC(2026, 11, 1, 8, 0, 0);
  var MAX_TIMER = 2147483647;

  var NOTE_EVERYDAY = 'Buy <strong>2</strong>, save <strong>10%</strong> · Buy <strong>3+</strong>, save <strong>15%</strong>';
  var NOTE_SALE = 'Buy <strong>2</strong>, save <strong>20%</strong> · Buy <strong>3+</strong>, save <strong>30%</strong>';

  /* [everyday wording, sale wording]. Exact text only, so wording changed in the theme editor is left alone. */
  var PHRASES = [
    ['Buy 2, Save 10% | Buy 3+, Save 15%', 'Black Friday: Buy 2, Save 20% | Buy 3+, Save 30%'],
    ['2 items 10% off, 3 or more 15% off', '2 items 20% off, 3 or more 30% off through Monday, Nov 30']
  ];
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1 };

  var SETS_PATH = '/collections/sets';
  var SETS_FROM = SALE_START - 6 * 3600000;
  var SETS_TO = SALE_END + 2 * 3600000;
  var SETS_LINKS = 'header a[href$="' + SETS_PATH + '"],.header a[href$="' + SETS_PATH + '"],[data-section-type="header"] a[href$="' + SETS_PATH + '"]';

  function inSale(){
    var t = Date.now();
    return t >= SALE_START && t < SALE_END;
  }

  var CSS = '.pg-vol-note{display:flex;align-items:center;gap:8px;font-size:.8rem;letter-spacing:.5px;color:var(--pg-text,#E0E0E0);border:1px solid rgba(62,224,207,.35);border-radius:2px;padding:8px 12px;background:rgba(62,224,207,.06);line-height:1.3}'
    + '.pg-vol-note__icon{color:var(--pg-cyan,#3EE0CF);font-size:.7rem;flex:0 0 auto}'
    + '.pg-vol-note__text strong{color:var(--pg-cyan,#3EE0CF);font-weight:600}'
    + '.pg-vol-note--pdp{margin:14px 0}.pg-vol-note--cart{margin:12px 0 4px}';

  function injectStyle(){
    if (document.getElementById('pg-vol-note-style')) return;
    var s = document.createElement('style');
    s.id = 'pg-vol-note-style';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function makeNote(variant){
    var el = document.createElement('div');
    el.className = 'pg-vol-note pg-vol-note--' + variant;
    el.setAttribute('data-pg-vol-note', variant);
    el.innerHTML = '<span class="pg-vol-note__icon" aria-hidden="true">◆</span>'
      + '<span class="pg-vol-note__text">' + (inSale() ? NOTE_SALE : NOTE_EVERYDAY) + '</span>';
    return el;
  }

  function injectPDP(){
    if (document.querySelector('[data-pg-vol-note="pdp"]')) return;
    var form = document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var atc = form.querySelector('.product-form__submit') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]');
    if (!atc) return;
    var holder = atc.closest('.product-form__submit-holder') || atc;
    holder.parentNode.insertBefore(makeNote('pdp'), holder);
  }

  function injectCart(){
    var bars = document.querySelectorAll('.free-shipping-bar');
    for (var i = 0; i < bars.length; i++){
      var bar = bars[i];
      if (bar.parentNode.querySelector('[data-pg-vol-note="cart"]')) continue;
      bar.parentNode.insertBefore(makeNote('cart'), bar.nextSibling);
    }
  }

  /* Swap the wording inside one text node. toSale true: everyday to sale. false: sale back to everyday. */
  function swapText(node, toSale){
    var v = node.nodeValue;
    if (!v || v.indexOf('%') === -1) return;
    var p = node.parentNode;
    if (p && p.nodeName && SKIP[p.nodeName.toUpperCase()]) return;
    var from = toSale ? 0 : 1, to = toSale ? 1 : 0, out = v;
    for (var i = 0; i < PHRASES.length; i++){
      if (out.indexOf(PHRASES[i][from]) !== -1) out = out.split(PHRASES[i][from]).join(PHRASES[i][to]);
    }
    if (out !== v) node.nodeValue = out;
  }

  function sweep(root, toSale){
    if (!root) return;
    if (root.nodeType === 3) { swapText(root, toSale); return; }
    if (root.nodeType !== 1 || !document.createTreeWalker) return;
    var walker = document.createTreeWalker(root, 4, null, false);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) swapText(nodes[i], toSale);
  }

  /* Bring everything on the page in line with the clock: the notes and the two phrases. */
  function applyWindow(){
    var sale = inSale();
    var html = sale ? NOTE_SALE : NOTE_EVERYDAY;
    var els = document.querySelectorAll('.pg-vol-note__text');
    for (var i = 0; i < els.length; i++) els[i].innerHTML = html;
    if (document.body) sweep(document.body, sale);
  }

  /* A page left open across the opening or the closing switches by itself. */
  function scheduleBoundary(){
    var now = Date.now();
    var next = now < SALE_START ? SALE_START : (now < SALE_END ? SALE_END : 0);
    if (!next) return;
    var wait = next - now + 1000;
    if (wait > MAX_TIMER) return;
    setTimeout(function () {
      try { applyWindow(); } catch (e) {}
      scheduleBoundary();
    }, wait);
  }

  function hideSetsLinks(){
    var links = document.querySelectorAll(SETS_LINKS);
    for (var i = 0; i < links.length; i++){
      var item = links[i].closest('li') || links[i];
      item.style.display = 'none';
      item.setAttribute('data-pg-sets-hidden', '1');
    }
  }

  /* Around sale week only: ask the store whether the Sets collection is empty, and hide its menu links if it is. */
  function checkSets(){
    var now = Date.now();
    if (now < SETS_FROM || now >= SETS_TO || !window.fetch) return;
    var cached = null;
    try { cached = JSON.parse(window.sessionStorage.getItem('pgSetsEmpty') || 'null'); } catch (e) {}
    if (cached && typeof cached.t === 'number' && now - cached.t >= 0 && now - cached.t < 600000){
      if (cached.empty) hideSetsLinks();
      return;
    }
    window.fetch(SETS_PATH + '/products.json?limit=1', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) return;
        var empty = j.products.length === 0;
        try { window.sessionStorage.setItem('pgSetsEmpty', JSON.stringify({ t: Date.now(), empty: empty })); } catch (e) {}
        if (empty) hideSetsLinks();
      })
      .catch(function () {});
  }

  function run(){
    injectStyle();
    if (document.body && document.body.classList.contains('template-product')) injectPDP();
    injectCart();
    if (inSale() && document.body) sweep(document.body, true);
    scheduleBoundary();
    try { checkSets(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  try {
    var mo = new MutationObserver(function (muts){
      var sale = inSale(), cart = false;
      for (var i = 0; i < muts.length; i++){
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++){
          var n = added[j];
          if (sale) sweep(n, true);
          if (!cart && n.nodeType === 1 && ((n.matches && n.matches('.free-shipping-bar')) || (n.querySelector && n.querySelector('.free-shipping-bar')))) cart = true;
        }
      }
      if (cart) injectCart();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
